import Collapsible from '@commons/components/Collapsible';
import RichText from '@commons/components/RichText';
import Text from '@commons/components/Text';
import { API_WEBSITE } from '@commons/utils/constants';

import type { FAQNodeProps } from '.';
import getFAQStructuredData from './StructuredData';

/**
 * FAQ node component for the Collapsible display type.
 */

const FAQNodeCollapsible = (faq: FAQNodeProps) => {
  const { question, answer, anchor } = faq;

  const structuredData = getFAQStructuredData(faq);

  const renderedQuestion = (
    <Text
      as="p"
      level="h4"
      transform={API_WEBSITE === 'aiia' ? undefined : 'uppercase'}
      marginBottom="none"
    >
      {question}
    </Text>
  );

  return (
    <>
      <Collapsible id={anchor} title={renderedQuestion} className="w-100">
        <RichText value={answer} />
      </Collapsible>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </>
  );
};

export default FAQNodeCollapsible;
